jQuery(($) => {
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Tweak UI in meganav menu meta fields
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  const panels = $('.wp-admin.post-type-meganav-menu .acf-flexible-content .values .layout');

  function setPanelHeaderText(panelHeader, text) {
    if (text) {
      panelHeader.text(text);
    } else {
      panelHeader.text('Panel');
    }
  }

  panels.each(function () {
    const panel = $(this);
    const panelHeader = panel.find('.acf-fc-layout-handle');
    const panelLabelField = panel.find('[data-name="menu_label"] input');

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle panel header label
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    
    if (panelLabelField.length) {
      panelHeader.text(panelLabelField.val());
      setPanelHeaderText(panelHeader, panelLabelField.val());
    }    

    panelLabelField.on('input', function () {
      setPanelHeaderText(panelHeader, $(this).val());
    });

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle panel level
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    const panelLevelField = panel.find('[data-name="panel_level"] select');
    const panelLevel = panelLevelField.val();

    if (panelLevel) {
      panel.addClass(`level-${panelLevel}`);
    }

    if (panelLevel == 1) {
      panelHeader.text('Root Panel');
    }

    panelLevelField.on('change', function () {
      const newLevel = $(this).val();
      panel.removeClass((index, className) => {
        return (className.match(/(^|\s)level-\S+/g) || []).join(' ');
      });
      panel.addClass(`level-${newLevel}`);
    });

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle panel toggle
    // It resets the header text when collapsed for some reason.
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    panelHeader.on('click', function () {
      setTimeout(() => {
        setPanelHeaderText(panelHeader, panelLabelField.val());
      }, 1500);
    });
  });
});
